import { Tooltip } from 'antd';
import React from 'react';
import i18n from '../../../i18n/config';
import { UserStatus } from '../../../models';
import { COLORS } from '../../../shared';
import { HasText } from './typography';

interface HasUserNameProps {
  fullName?: string;
  deleted?: boolean;
  status?: UserStatus;
}

export const HasUserName = ({ fullName, deleted, status }: HasUserNameProps) => {
  const inactive = status === UserStatus.INACTIVE;

  if (!deleted && !inactive) {
    return <HasText content={fullName} />;
  }

  return (
    <Tooltip
      title={
        deleted
          ? i18n.t('user.deletedTooltip', 'This user was deleted')
          : i18n.t('user.inactiveTooltip', 'This user is inactive')
      }
      overlayStyle={{ fontSize: 12, fontWeight: 500 }}
    >
      <span>
        <HasText content={fullName} style={{ color: COLORS.LIGHT_RED, fontWeight: 600 }} />
      </span>
    </Tooltip>
  );
};
